import { Services } from '@sigma-frontend-libs/commons'

import { permissionPresets } from '@/utils'

import characters from '@/components/services/url-shortener/commons/item/characters'
import expireFields from '@/components/services/url-shortener/commons/item/expireFields'
import generationParams from '@/components/services/url-shortener/commons/item/generationParams'
import sticker from '@/components/sticker'
import actions from '@/components/templates/service/item/actions'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderFullUrl(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value.fullUrl,
        label: this.getTranslate(`${Services['url-shortener']}.labels.fullUrl`),
        to: {
          name: `${Services['url-shortener']}.single`,
          params: { id: this.value.id }
        },
        copy: true
      }
    }
  )
}
function renderShortUrl(h) {
  if (this.viewport.size.width > 480) {
    return h(
      sticker,
      {
        props: {
          value: this.shortUrl,
          label: this.getTranslate(`${Services['url-shortener']}.labels.shortUrl`),
          copy: true
        }
      }
    )
  }
}
function renderPresetOrDomain(h) {
  if (this.viewport.size.width > 1280) {
    if (this.$_presetId || this.$_domainId) {
      return h(
        sticker,
        {
          props: this.presetOrDomainStickerProps
        }
      )
    }

    return h('div')
  }
}
function renderOwner(h) {
  if (this.viewport.size.width > 1440) {
    if (this.hasOwner) {
      return h(
        owner,
        {
          props: {
            value: this.value,
            copy: true
          }
        }
      )
    }
  }
}
function renderCharacters(h) {
  return h(
    characters,
    {
      props: {
        value: this.$_generationParams
      }
    }
  )
}
function renderGenerationParams(h) {
  return h(
    generationParams,
    {
      props: {
        value: this.$_generationParams
      }
    }
  )
}
function renderExpireFields(h) {
  return h(
    expireFields,
    {
      props: {
        value: this.value
      }
    }
  )
}
function renderIcons(h) {
  if (this.viewport.size.width > 1600) {
    return h(
      'div',
      {
        class: `${Services['url-shortener']}-item__icons`
      },
      [
        renderCharacters.call(this, h),
        renderGenerationParams.call(this, h),
        renderExpireFields.call(this, h)
      ]
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services['url-shortener']}-item__info`]: true,
        [`${Services['url-shortener']}-item__info--admin`]: this.canGetUsers
      }
    },
    [
      renderFullUrl.call(this, h),
      renderShortUrl.call(this, h),
      renderPresetOrDomain.call(this, h),
      renderOwner.call(this, h),
      renderIcons.call(this, h)
    ]
  )
}

function renderButtons(h) {
  return h(
    actions,
    {
      props: {
        value: this.value,
        service: Services['url-shortener'],
        accept: permissionPresets.meUp,
        removeCallback: () => {
          this.$emit('remove', this.value.id)
        }
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        ['service-template-item']: true,
        ['hover-parent hover-parent--opacity']: this.viewport.breakpoint.mdUp,
        [`${Services['url-shortener']}-item`]: true
      }
    },
    [
      renderInfo.call(this, h),
      renderButtons.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
